import sortArrayRemoveDuplicates from "./sortedArrayRemoveDuplicates";

const getAllTeamMembersPromise = (api, teamIDs) => {
    
    if(!teamIDs){
        return Promise.resolve([]);
    }
    return Promise.all( teamIDs?.map( t => getTeamMembersPromiseForTeam(api, t) ) )
        .then(r => r.flat())
        .then(r => sortArrayRemoveDuplicates( r, (a, b) => a.FullName.localeCompare(b.FullName) ))
        .then(r => {
            const result = [...r];

            const cliniciansByID = result.reduce( (prev, curr) => {
                const newResult = {...prev};
                if(!prev.hasOwnProperty(curr.ClinicianPartyID)){
                    newResult[curr.ClinicianPartyID] = curr;
                }
                return newResult;
            }, {} );

            return { clinicians: result, cliniciansByID };
        });    
}

const getTeamMembersPromiseForTeam = (api, teamID) => 
    api.transact('TeamMemberList', {TeamID: teamID})
    .then(a => a.apiResult)
    .then(a => a.map(a => ({ ClinicianPartyID: a.pkPartyID, TeamID: teamID, FirstName: a.FirstName, LastName: a.LastName, 
        FullName: ('' + a.LastName + ' ' + a.FirstName) })));

export default getAllTeamMembersPromise;